import React from 'react';
import Input from '../Input';
import SearchIcon from '../../../icons/search.svg';

import './SearchInput.scss';

export default (props) => <Input {...props} leftIcon={<SearchIcon styleName="icon" />} />;
